import * as React from 'react'
import { TRIPS_HISTORY_COLUMNS } from '../../state/constants/index'
import ListColumnsMenu from '../ui/ListColumnsMenu'
import MenuItem from '../ui/MenuItem'

interface ITripsHistoryColumnsMenuProps {
  columns: string[]
  onUpdateColumns: (columns: string[]) => void
}

const TripsHistoryColumnsMenu = ({ columns = [], onUpdateColumns }: ITripsHistoryColumnsMenuProps) => {
  const createColumnClickHandler = (column: string) => () => {
    let updatedColumns
    if (columns.indexOf(column) !== -1) {
      updatedColumns = columns.filter(it => it !== column)
    } else {
      updatedColumns = [...columns, column]
    }
    onUpdateColumns(updatedColumns)
  }

  return (
    <ListColumnsMenu>
      <div className='flex flex-column items-start pl2 pr2 pb2' style={{ width: '200px' }}>
        <p className='h5 font-grey2'>SHOW COLUMNS</p>
        {[
          TRIPS_HISTORY_COLUMNS.DATE,
          TRIPS_HISTORY_COLUMNS.PICKUP_TIME,
          TRIPS_HISTORY_COLUMNS.ARRIVAL_TIME,
          TRIPS_HISTORY_COLUMNS.STATUS,
          TRIPS_HISTORY_COLUMNS.RIDER_NAME,
          TRIPS_HISTORY_COLUMNS.PROVIDER,
          TRIPS_HISTORY_COLUMNS.SERVICE,
          TRIPS_HISTORY_COLUMNS.COST,
          TRIPS_HISTORY_COLUMNS.FARE
        ].map(it => {
          const checked = columns.indexOf(it) !== -1
          return (
            <MenuItem key={`column-${it}`} name={it} checked={checked} handleClick={createColumnClickHandler(it)} />
          )
        })}
      </div>
    </ListColumnsMenu>
  )
}

export default TripsHistoryColumnsMenu



// WEBPACK FOOTER //
// ./src/components/trips/TripsHistoryColumnsMenu.tsx